(function() {
  'use strict';

  angular.module('app.maps')
    .controller('PublicMapCtrl', PublicMapCtrl);

  /** @ngInject */
  function PublicMapCtrl($scope, esriLoader, esriRegistry, $rootScope, SidePanelLayers, $templateCache, $uibModal, panels) {
    let vm = this;
    let relguids = [];

    // Inspection Status dropdown
    vm.inspectionStatuses = [
      'All',
      'Confirmed',
      'Corrected',
      'Needs Inspection',
      'Not Inspected',
      'Survey Required'
    ];

    vm.isCollapsed = true;
    vm.toggleAllFilters = function() {
      console.log('toggleAllFilters');
      if (vm.isCollapsed === true) {
        vm.isCollapsed = false;
      } else {
        vm.isCollapsed = true;
      }
      console.log(vm.isCollapsed);
    };

    vm.openHelp = function() {
      console.log('openHelp');
      $uibModal.open({
        animation: true,
        template: $templateCache.get('modules/core/modals/contact.tpl.html'),
        controller: 'ContactUsCtrl',
        size: 'sm'
      });
    };




    // get the list of inspected by
    // for (let i in $rootScope.domains) {
    //   if ($rootScope.domains[i].name === 'InspectedBy') {
    //     vm.inspectors = $rootScope.domains[i].domain;
    //   }
    // }

    // Inspection Status dropdown
    // maps.getZoomShortCuts().then(function(data) {
    //   vm.quickZoomLocations = data;
    // });

    vm.openLayers = function() {
      if (panels.opened == null) {
        panels.open('layersPanel');
      } else {
        panels.close();
      }
    };

    vm.zoomTo = function() {
      esriLoader.require([
          'esri/geometry/Polygon',
          'esri/SpatialReference'
        ],
        function(Polygon,
          SpatialReference) {
          for (let i in vm.quickZoomLocations) {
            if (vm.quickZoomLocations[i].name === vm.location) {
              let polygon = new Polygon(vm.quickZoomLocations[i].geometry);
              polygon.setSpatialReference(new SpatialReference({
                wkid: 103403
              }));
              // zoom to the selected location
              vm.map.setExtent(polygon.getExtent());
            }
          }
        });
    };

    vm.filterStatus = function() {
      for (let i = 0, loop = vm.map.graphicsLayerIds.length; i < loop; i++) {
        let layer = vm.map.getLayer(vm.map.graphicsLayerIds[i]);
        if (layer.name === 'Structures') {
          let defQuery = createQuery();
          layer.setDefinitionExpression(defQuery);
        }
      }
    };

    vm.filterByInspector = function() {
      esriLoader.require([
        'esri/request'
      ], function(
        esriRequest
      ) {
        if (vm.inspector !== 'Reset') {
          let where = "InspectedBy = '" + vm.inspector + "'"; // jshint ignore:line
          // with esri request
          let requestHandle = esriRequest({
            'url': $rootScope.config.services.permits + '/query',
            'content': {
              'f': 'json',
              'where': where,
              'outFields': ['*'],
              'returnGeometry': false
            },
            'handeAs': 'json',
            'callbackParamName': 'callback'
          });
          requestHandle.then(function(results) {
            let features = results.features;
            relguids = [];
            for (let i in features) {
              relguids.push(features[i].attributes.RelGUID);
            }
            // filter from the structures feature service
            for (let i = 0, loop = vm.map.graphicsLayerIds.length; i < loop; i++) {
              let layer = vm.map.getLayer(vm.map.graphicsLayerIds[i]);
              if (layer.name === 'Structures') {
                let defQuery = createQuery();
                layer.setDefinitionExpression(defQuery);
              }
            }
          }, function(results) {
            console.log(results);
          });
        } else {
          relguids = [];
          for (let i = 0, loop = vm.map.graphicsLayerIds.length; i < loop; i++) {
            let layer = vm.map.getLayer(vm.map.graphicsLayerIds[i]);
            if (layer.name === 'Structures') {
              let defQuery = createQuery();
              layer.setDefinitionExpression(defQuery);
            }
          }
        }
      });
    };

    $scope.$on('$destroy', function destroy() {
      esriLoader.require(['dijit/registry'], function(registry) {
        for (let value of registry.toArray()) {
          value.destroyRecursive();
        }
        // clear out the side panel layers when switching maps
        SidePanelLayers.clearLayers();
      });
    });

    function createQuery() {
      let queryString = '';
      let queryArray = [];
      // add the inspection Status
      let status = '';
      if (vm.inspectionStatus !== 'All') {
        status = 'InspectionStatus = \'' + vm.inspectionStatus + '\'';
        queryArray.push(status);
      }
      // add the inspector
      let inspector = '';
      if (vm.inspector !== 'Reset' && relguids.length !== 0) {
        inspector = 'GlobalID IN ' + '(\'' + relguids.join('\', \'') + '\')';
        queryArray.push(inspector);
      }
      // create the queryString
      if (queryArray.length > 1) {
        queryString = queryArray.join(' AND ');
        return queryString;
      } else {
        queryString = status + inspector;
        return queryString;
      }
    }
  }
})();
